import React, { useRef, useState, useEffect } from 'react';
import * as Yup from 'yup';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';

import { APP_LABELS, FIELD_LENGTH } from '@config/app-config';
import Help from '@modules/shared/components/reusable-components/help';
import SuccessToaster from '@modules/shared/components/reusable-components/success-toaster';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';
import PartialSaveWarningPopup from '@modules/shared/components/reusable-components/partial-save-popup';
import LastUpdateName from '@modules/annual-reports/components/anuual-reports-overview/last-update-name';

import {
  resetReduxState,
  getOvernightCampDataTotalStaff,
  postOvernightCampDataTotalStaff
} from '@redux/overnight-camp-data-staff/action';
import { getCampReportsDashboardOverviewData } from '@redux/overnight-camp-data-overview/action';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { GetTotalStaffSelector } from '@redux/overnight-camp-data-staff/selectors';
import { ApiParaSelector } from '@redux/overnight-camp-data-apiParameter/selectors';

import helpicon from '@static/images/caretdoubleright.svg';

const TotalStaff = props => {
  const formikref = useRef();
  const {
    status,
    setLoader,
    LoginUserData,
    ApiParameterData,
    handleResetRedux,
    GetTotalStaffData,
    handleGetCampReportsDashboard,
    handleGetOvernightCampDataTotalStaff,
    handlePostOvernightCampDataTotalStaff
  } = props;

  const role = get(LoginUserData, 'user.role[0]');

  const [help, setHelp] = useState(false);
  const [instructions, setInstructions] = useState('');
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successPopup, setSuccessPopup] = useState(false);
  const [totalIsNotEqual, setTotalIsNotEqual] = useState(false);
  const [errorMessageForTotal, setErrorMessageForTotal] = useState('');

  const [resStatus, setResStatus] = useState();

  const initialValues = {
    fullTime: '',
    nonFullTimeExempt: '',
    partTime: '',
    numberOfMedicalStaffIncludedInCount: '',
    numberOfInternationalStaffIncludedInCount: '',
    total: '',

    raceEthnicAsian: '',
    raceEthnicAsianNotCollected: false,

    raceEthnicBlackOrAfricanAmerican: '',
    raceEthnicBlackOrAfricanAmericanNotCollected: false,

    raceEthnicHispanicLatino: '',
    raceEthnicHispanicLatinoNotCollected: false,

    raceEthnicMiddleEasternOrNorthernAfrican: '',
    raceEthnicMiddleEasternOrNorthernAfricanNotCollected: false,

    raceEthnicNativeAmericanOrAlaskanNative: '',
    raceEthnicNativeAmericanOrAlaskanNativeNotCollected: false,

    raceEthnicNativeHawaiianOrOtherPacificIslander: '',
    raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected: false,

    raceEthnicWhite: '',
    raceEthnicWhiteNotCollected: false,

    raceEthnicTwoOrMoreRacesEthnicities: '',
    raceEthnicTwoOrMoreRacesEthnicitiesNotCollected: false,

    raceEthnicOther: '',
    raceEthnicOtherNotCollected: false,

    raceEthnicUnknown: '',
    raceEthnicUnknownNotCollected: false,

    raceEthnicTotalMembers: '',

    genderFemale: '',
    genderFemaleNotCollected: false,

    genderMale: '',
    genderMaleNotCollected: false,

    genderUnknown: '',
    genderUnknownNotCollected: false,

    genderTotalMembers: ''
  };

  const editValues = {
    fullTime: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.FullTime
      : null,
    nonFullTimeExempt: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.FullTimeNonExempt
      : null,
    partTime: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.PartTimeSeasonalTemporary
      : null,
    numberOfMedicalStaffIncludedInCount: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.NoOfMedicalStaffIncludedInCount
      : null,
    numberOfInternationalStaffIncludedInCount: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.NoOfInternationalStaffIncludedInCount
      : null,

    raceEthnicAsian: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.Asian
      : null,
    raceEthnicAsianNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.AsianNotCollected !== null
        ? GetTotalStaffData.data[0].AsianNotCollected
        : false,

    raceEthnicBlackOrAfricanAmerican: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.BlackOrAfricanAmerican
      : null,
    raceEthnicBlackOrAfricanAmericanNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.BlackOrAfricanAmericanNotCollected !== null
        ? GetTotalStaffData?.data[0]?.BlackOrAfricanAmericanNotCollected
        : false,

    raceEthnicHispanicLatino: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.HispanicLatino
      : null,
    raceEthnicHispanicLatinoNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.HispanicLatinoNotCollected !== null
        ? GetTotalStaffData?.data[0]?.HispanicLatinoNotCollected
        : false,

    raceEthnicMiddleEasternOrNorthernAfrican: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.MiddleEastNorthAfrican
      : null,
    raceEthnicMiddleEasternOrNorthernAfricanNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.MiddleEastNorthAfricanNotCollected !== null
        ? GetTotalStaffData?.data[0]?.MiddleEastNorthAfricanNotCollected
        : false,

    raceEthnicNativeAmericanOrAlaskanNative: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.NativeAmericanAlaskanNative
      : null,
    raceEthnicNativeAmericanOrAlaskanNativeNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.NativeAmericanAlaskanNativeNotCollected !==
        null
        ? GetTotalStaffData?.data[0]?.NativeAmericanAlaskanNativeNotCollected
        : false,

    raceEthnicNativeHawaiianOrOtherPacificIslander: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.NativeHawaiianOtherPacificIslanderNative
      : null,
    raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]
        ?.NativeHawaiianOtherPacificIslanderNativeNotCollected !== null
        ? GetTotalStaffData?.data[0]
            ?.NativeHawaiianOtherPacificIslanderNativeNotCollected
        : false,

    raceEthnicWhite: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.White
      : null,
    raceEthnicWhiteNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.WhiteNotCollected !== null
        ? GetTotalStaffData?.data[0]?.WhiteNotCollected
        : false,

    raceEthnicTwoOrMoreRacesEthnicities: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.TwoOrMoreRaces
      : null,
    raceEthnicTwoOrMoreRacesEthnicitiesNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.TwoOrMoreRacesNotCollected !== null
        ? GetTotalStaffData?.data[0]?.TwoOrMoreRacesNotCollected
        : false,

    raceEthnicOther: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.Other
      : null,
    raceEthnicOtherNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.OtherNotCollected !== null
        ? GetTotalStaffData?.data[0]?.OtherNotCollected
        : false,

    raceEthnicUnknown: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.RaceUnknown
      : null,
    raceEthnicUnknownNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.RaceUnknownNotCollected !== null
        ? GetTotalStaffData?.data[0]?.RaceUnknownNotCollected
        : false,

    genderFemale: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.Female
      : null,
    genderFemaleNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.FemaleNotCollected !== null
        ? GetTotalStaffData?.data[0]?.FemaleNotCollected
        : false,

    genderMale: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.Male
      : null,
    genderMaleNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.MaleNotCollected !== null
        ? GetTotalStaffData?.data[0]?.MaleNotCollected
        : false,

    genderUnknown: GetTotalStaffData?.data
      ? GetTotalStaffData?.data[0]?.GenderUnknown
      : null,
    genderUnknownNotCollected:
      GetTotalStaffData?.data?.length &&
      GetTotalStaffData.data[0]?.GenderUnknownNotCollected !== null
        ? GetTotalStaffData?.data[0]?.GenderUnknownNotCollected
        : false
  };

  const validationSchema = Yup.object({
    fullTime: Yup.string().nullable(),
    nonFullTimeExempt: Yup.string().nullable(),
    partTime: Yup.string().nullable(),
    numberOfMedicalStaffIncludedInCount: Yup.string().nullable(),
    numberOfInternationalStaffIncludedInCount: Yup.string().nullable(),
    total: Yup.string().nullable(),

    raceEthnicAsian: Yup.string().nullable(),
    raceEthnicAsianNotCollected: Yup.string().nullable(),

    raceEthnicBlackOrAfricanAmerican: Yup.string().nullable(),
    raceEthnicBlackOrAfricanAmericanNotCollected: Yup.string().nullable(),

    raceEthnicHispanicLatino: Yup.string().nullable(),
    raceEthnicHispanicLatinoNotCollected: Yup.string().nullable(),

    raceEthnicMiddleEasternOrNorthernAfrican: Yup.string().nullable(),
    raceEthnicMiddleEasternOrNorthernAfricanNotCollected:
      Yup.string().nullable(),

    raceEthnicNativeAmericanOrAlaskanNative: Yup.string().nullable(),
    raceEthnicNativeAmericanOrAlaskanNativeNotCollected:
      Yup.string().nullable(),

    raceEthnicNativeHawaiianOrOtherPacificIslander: Yup.string().nullable(),
    raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected:
      Yup.string().nullable(),

    raceEthnicWhite: Yup.string().nullable(),
    raceEthnicWhiteNotCollected: Yup.string().nullable(),

    raceEthnicTwoOrMoreRacesEthnicities: Yup.string().nullable(),
    raceEthnicTwoOrMoreRacesEthnicitiesNotCollected: Yup.string().nullable(),

    raceEthnicOther: Yup.string().nullable(),
    raceEthnicOtherNotCollected: Yup.string().nullable(),

    raceEthnicUnknown: Yup.string().nullable(),
    raceEthnicUnknownNotCollected: Yup.string().nullable(),

    raceEthnicTotalMembers: Yup.string().nullable(),

    genderFemale: Yup.string().nullable(),
    genderFemaleNotCollected: Yup.string().nullable(),

    genderMale: Yup.string().nullable(),
    genderMaleNotCollected: Yup.string().nullable(),

    genderUnknown: Yup.string().nullable(),
    genderUnknownNotCollected: Yup.string().nullable(),

    genderTotalMembers: Yup.string().nullable()
  });

  const handleGetCall = success => {
    setLoader(true);
    handleGetOvernightCampDataTotalStaff(
      ApiParameterData?.branchNumber,
      ApiParameterData?.reportBatchId,
      ApiParameterData?.year
    ).then(res => {
      if (res.status === 200) {
        setLoader(false);
        if (success) {
          setSuccessPopup(true);
        }
      } else {
        setLoader(false);
        setErrorMessage(APP_LABELS.COMMON_ERROR_MESSAGE);
        setErrorPopup(true);
      }
    });
  };

  useEffect(() => {
    handleGetCall();
    setInstructions(
      JSON.parse(sessionStorage.getItem('allinstructions'))['total-staff']
        ?.Instruction
    );
    return () => {
      handleResetRedux('getYusaOvernightCampStaff');
    };
  }, []);

  const handleShowHelp = () => {
    setHelp(true);
  };

  const hideShowHelp = () => {
    setHelp(false);
  };

  const getClassNames = (errorsValue, touchedValue, checkboxValue) => {
    let className = 'ymca-field';

    if (errorsValue && touchedValue) {
      className = 'ymca-field invalid';
    } else if (checkboxValue) {
      className = 'ymca-field ymca-fieldDisabled';
    }
    return className;
  };

  const handleChange = (e, setFieldValue, name) => {
    const result = e.target.value.replace(/\D+/g, '');
    setFieldValue(name, result);
  };

  const convertedValue = value => (value === 0 || value ? Number(value) : null);

  const calculateTotal = (
    number1 = 0,
    number2 = 0,
    number3 = 0,
    number4 = 0,
    number5 = 0,
    number6 = 0,
    number7 = 0,
    number8 = 0,
    number9 = 0,
    number10 = 0,
    number11 = 0
  ) =>
    Number(number1) +
    Number(number2) +
    Number(number3) +
    Number(number4) +
    Number(number5) +
    Number(number6) +
    Number(number7) +
    Number(number8) +
    Number(number9) +
    Number(number10) +
    Number(number11);

  const onSubmit = values => {
    setLoader(true);
    const total = calculateTotal(
      values?.fullTime,
      values?.nonFullTimeExempt,
      values?.partTime
    );
    const raceTotal = calculateTotal(
      values?.raceEthnicAsianNotCollected ? 0 : values?.raceEthnicAsian,
      values?.raceEthnicBlackOrAfricanAmericanNotCollected
        ? 0
        : values?.raceEthnicBlackOrAfricanAmerican,
      values?.raceEthnicHispanicLatinoNotCollected
        ? 0
        : values?.raceEthnicHispanicLatino,
      values?.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
        ? 0
        : values?.raceEthnicMiddleEasternOrNorthernAfrican,
      values?.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
        ? 0
        : values?.raceEthnicNativeAmericanOrAlaskanNative,
      values?.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
        ? 0
        : values?.raceEthnicNativeHawaiianOrOtherPacificIslander,
      values?.raceEthnicWhiteNotCollected ? 0 : values?.raceEthnicWhite,
      values?.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
        ? 0
        : values?.raceEthnicTwoOrMoreRacesEthnicities,
      values?.raceEthnicOtherNotCollected ? 0 : values?.raceEthnicOther,
      values?.raceEthnicUnknownNotCollected ? 0 : values?.raceEthnicUnknown
    );

    const genderTotal = calculateTotal(
      values?.genderMaleNotCollected ? 0 : values?.genderMale,
      values?.genderFemaleNotCollected ? 0 : values.genderFemale,
      values?.genderUnknownNotCollected ? 0 : values.genderUnknown
    );

    if (total !== genderTotal || genderTotal !== raceTotal) {
      setLoader(false);
      setTotalIsNotEqual(true);
      setErrorMessageForTotal(
        '* The total number of staff, race/ethnicity, and sex must match.'
      );
    } else {
      setTotalIsNotEqual(false);
      setErrorMessageForTotal('');
    }

    const payloadBody = {
      Staff: {
        CreatedByPersonId: LoginUserData?.user?.personBranchId,
        UpdatedByPersonId: LoginUserData?.user?.personBranchId,

        Year: ApiParameterData?.year,
        BranchNumber: ApiParameterData?.branchNumber,
        ReportBatchId: ApiParameterData?.reportBatchId,

        RecordStatus: `${GetTotalStaffData?.data[0]?.RecordStatus}`,
        TotalStaffId:
          GetTotalStaffData?.data[0]?.TotalStaffId === undefined
            ? 0
            : GetTotalStaffData?.data[0]?.TotalStaffId,

        FullTime: convertedValue(values.fullTime),
        FullTimeNonExempt: convertedValue(values.nonFullTimeExempt),
        PartTimeSeasonalTemporary: convertedValue(values.partTime),
        NoOfInternationalStaffIncludedInCount: convertedValue(
          values.numberOfInternationalStaffIncludedInCount
        ),
        NoOfMedicalStaffIncludedInCount: convertedValue(
          values.numberOfMedicalStaffIncludedInCount
        ),

        Asian: values.raceEthnicAsianNotCollected
          ? null
          : convertedValue(values.raceEthnicAsian),
        AsianNotCollected: values.raceEthnicAsianNotCollected,

        BlackOrAfricanAmerican:
          values.raceEthnicBlackOrAfricanAmericanNotCollected
            ? null
            : convertedValue(values.raceEthnicBlackOrAfricanAmerican),
        BlackOrAfricanAmericanNotCollected:
          values.raceEthnicBlackOrAfricanAmericanNotCollected,

        HispanicLatino: values.raceEthnicHispanicLatinoNotCollected
          ? null
          : convertedValue(values.raceEthnicHispanicLatino),
        HispanicLatinoNotCollected: values.raceEthnicHispanicLatinoNotCollected,

        MiddleEastNorthAfrican:
          values.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
            ? null
            : convertedValue(values.raceEthnicMiddleEasternOrNorthernAfrican),
        MiddleEastNorthAfricanNotCollected:
          values.raceEthnicMiddleEasternOrNorthernAfricanNotCollected,

        NativeAmericanAlaskanNative:
          values.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
            ? null
            : convertedValue(values.raceEthnicNativeAmericanOrAlaskanNative),
        NativeAmericanAlaskanNativeNotCollected:
          values.raceEthnicNativeAmericanOrAlaskanNativeNotCollected,

        NativeHawaiianOtherPacificIslanderNative:
          values.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
            ? null
            : convertedValue(
                values.raceEthnicNativeHawaiianOrOtherPacificIslander
              ),
        NativeHawaiianOtherPacificIslanderNativeNotCollected:
          values.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected,

        White: values.raceEthnicWhiteNotCollected
          ? null
          : convertedValue(values.raceEthnicWhite),
        WhiteNotCollected: values.raceEthnicWhiteNotCollected,

        TwoOrMoreRaces: values.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
          ? null
          : convertedValue(values.raceEthnicTwoOrMoreRacesEthnicities),
        TwoOrMoreRacesNotCollected:
          values.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected,

        RaceUnknown: values.raceEthnicUnknownNotCollected
          ? null
          : convertedValue(values.raceEthnicUnknown),
        RaceUnknownNotCollected: values.raceEthnicUnknownNotCollected,

        Other: values.raceEthnicOtherNotCollected
          ? null
          : convertedValue(values.raceEthnicOther),
        OtherNotCollected: values.raceEthnicOtherNotCollected,

        Male: values.genderMaleNotCollected
          ? null
          : convertedValue(values.genderMale),
        MaleNotCollected: values.genderMaleNotCollected,

        Female: values.genderFemaleNotCollected
          ? null
          : convertedValue(values.genderFemale),
        FemaleNotCollected: values.genderFemaleNotCollected,

        GenderUnknown: values.genderUnknownNotCollected
          ? null
          : convertedValue(values.genderUnknown),
        GenderUnknownNotCollected: values.genderUnknownNotCollected,

        RaceTotalMembers: raceTotal,
        TotalMembers: genderTotal
      }
    };

    setSuccessPopup(false);
    handlePostOvernightCampDataTotalStaff(payloadBody).then(res => {
      if (res.status === 201 && res?.data?.isSuccess) {
        setResStatus(res.data?.RecordStatus);
        handleGetCall(true);
        handleGetCampReportsDashboard(
          ApiParameterData?.branchNumber,
          ApiParameterData?.year
        );
      } else if (res.statusCode === 409) {
        setLoader(false);
        setErrorMessage(res.errorMessage);
        setErrorPopup(true);
      } else {
        setLoader(false);
        setErrorPopup(true);
      }
    });
  };

  return (
    <>
      <button
        type="button"
        className="ymca-help-link text-decoration-none ymca-up-data-help-link annual-report-help"
        onClick={handleShowHelp}
      >
        <span>HELP</span>

        <img src={helpicon} className="img-fluid" alt="caret-icon" />
      </button>

      <div className="ymca-program">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-3">
          <div className="ymca-instructionBoxes mb-2">
            <h4 className="ymca-instructHeadline">{APP_LABELS.INSTRUCTIONS}</h4>
            <p className="ymca-instructTitle">
              <div
                dangerouslySetInnerHTML={{
                  __html: instructions
                }}
              />
            </p>
          </div>
          {GetTotalStaffData?.data &&
            GetTotalStaffData?.data[0]?.RecordStatus === 'Partial' && (
              <PartialSaveWarningPopup />
            )}
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="ymca-selectWrap">
            <div className="ymca-programActivities txt-mandatory">
              How many staff did your Camp employ for Summer Overnight Camp this
              past season? Please use the table below to indicate how many were
              Full-time exempt, Full-time Non-exempt, or
              Part-time/Seasonal/Temporary.
            </div>
          </div>
        </div>

        <Formik
          innerRef={formikref}
          initialValues={editValues || initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, errors, touched, dirty }) => {
            sessionStorage.setItem('dirty', dirty);
            return (
              <Form autoComplete="off">
                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>No. of Staff</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td className="txt-mandatory">Full-time</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="fullTime"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.fullTime,
                              touched.fullTime
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'fullTime')
                            }
                            value={values.fullTime}
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Full-time Non-exempt</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="nonFullTimeExempt"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.nonFullTimeExempt,
                              touched.nonFullTimeExempt
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'nonFullTimeExempt'
                              )
                            }
                            value={values.nonFullTimeExempt}
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Part-time/Seasonal/Temporary
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="partTime"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.partTime,
                              touched.partTime
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'partTime')
                            }
                            value={values.partTime}
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                      <tr>
                        <td className="">Total</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="total"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className="ymca-field ymca-fieldDisabled"
                            value={calculateTotal(
                              values?.fullTime,
                              values?.nonFullTimeExempt,
                              values?.partTime
                            )}
                            disabled
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                      <tr>
                        <td className="txt-mandatory">
                          No. of International Staff Included In count
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="numberOfInternationalStaffIncludedInCount"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.numberOfInternationalStaffIncludedInCount,
                              touched.numberOfInternationalStaffIncludedInCount
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'numberOfInternationalStaffIncludedInCount'
                              )
                            }
                            value={
                              values.numberOfInternationalStaffIncludedInCount
                            }
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          No. of Paid Medical Staff Included In count
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="numberOfMedicalStaffIncludedInCount"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.numberOfMedicalStaffIncludedInCount,
                              touched.numberOfMedicalStaffIncludedInCount
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'numberOfMedicalStaffIncludedInCount'
                              )
                            }
                            value={values.numberOfMedicalStaffIncludedInCount}
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="ymca-selectWrap">
                    <div className="ymca-programActivities txt-mandatory">
                      Please tell us how many of your Overnight Camp Summer
                      Staff fall into each of the Race/Ethnicity and Sex
                      categories below. The total No. of Staff reported using
                      the Race/Ethnicity and Sex table below much match the
                      total number of Overnight Summer Camp Staff reported
                      above.
                    </div>
                  </div>
                </div>
                <span className="ymca-program p-0">
                  <h6 className="ymca-programActivities">
                    Please click in the checkbox if this Race/Ethnic category is
                    not collected.
                  </h6>
                </span>

                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>No. of Staff</th>
                        <th className="ymca-defaultSpace">Not Collected</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td className="txt-mandatory">Asian</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicAsian"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicAsian,
                              touched.raceEthnicAsian,
                              values.raceEthnicAsianNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'raceEthnicAsian')
                            }
                            value={
                              values.raceEthnicAsianNotCollected
                                ? ''
                                : values.raceEthnicAsian
                            }
                            disabled={values.raceEthnicAsianNotCollected}
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicAsianNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Black or African American
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicBlackOrAfricanAmerican"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicBlackOrAfricanAmerican,
                              touched.raceEthnicBlackOrAfricanAmerican,
                              values.raceEthnicBlackOrAfricanAmericanNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicBlackOrAfricanAmerican'
                              )
                            }
                            value={
                              values.raceEthnicBlackOrAfricanAmericanNotCollected
                                ? ''
                                : values.raceEthnicBlackOrAfricanAmerican
                            }
                            disabled={
                              values.raceEthnicBlackOrAfricanAmericanNotCollected
                            }
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicBlackOrAfricanAmericanNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Hispanic / Latino</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicHispanicLatino"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicHispanicLatino,
                              touched.raceEthnicHispanicLatino,
                              values.raceEthnicHispanicLatinoNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicHispanicLatino'
                              )
                            }
                            value={
                              values.raceEthnicHispanicLatinoNotCollected
                                ? ''
                                : values.raceEthnicHispanicLatino
                            }
                            disabled={
                              values.raceEthnicHispanicLatinoNotCollected
                            }
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicHispanicLatinoNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Middle Eastern or Northern African
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicMiddleEasternOrNorthernAfrican"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicMiddleEasternOrNorthernAfrican,
                              touched.raceEthnicMiddleEasternOrNorthernAfrican,
                              values.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicMiddleEasternOrNorthernAfrican'
                              )
                            }
                            value={
                              values.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
                                ? ''
                                : values.raceEthnicMiddleEasternOrNorthernAfrican
                            }
                            disabled={
                              values.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
                            }
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicMiddleEasternOrNorthernAfricanNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Native American or Alaskan Native
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicNativeAmericanOrAlaskanNative"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicNativeAmericanOrAlaskanNative,
                              touched.raceEthnicNativeAmericanOrAlaskanNative,
                              values.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicNativeAmericanOrAlaskanNative'
                              )
                            }
                            value={
                              values.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
                                ? ''
                                : values.raceEthnicNativeAmericanOrAlaskanNative
                            }
                            disabled={
                              values.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
                            }
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicNativeAmericanOrAlaskanNativeNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Native Hawaiian or Other Pacific Islander
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicNativeHawaiianOrOtherPacificIslander"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicNativeHawaiianOrOtherPacificIslander,
                              touched.raceEthnicNativeHawaiianOrOtherPacificIslander,
                              values.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicNativeHawaiianOrOtherPacificIslander'
                              )
                            }
                            value={
                              values.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
                                ? ''
                                : values.raceEthnicNativeHawaiianOrOtherPacificIslander
                            }
                            disabled={
                              values.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
                            }
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">White</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicWhite"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicWhite,
                              touched.raceEthnicWhite,
                              values.raceEthnicWhiteNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'raceEthnicWhite')
                            }
                            value={
                              values.raceEthnicWhiteNotCollected
                                ? ''
                                : values.raceEthnicWhite
                            }
                            disabled={values.raceEthnicWhiteNotCollected}
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicWhiteNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Two or More Races / Ethnicities
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicTwoOrMoreRacesEthnicities"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicTwoOrMoreRacesEthnicities,
                              touched.raceEthnicTwoOrMoreRacesEthnicities,
                              values.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicTwoOrMoreRacesEthnicities'
                              )
                            }
                            value={
                              values.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
                                ? ''
                                : values.raceEthnicTwoOrMoreRacesEthnicities
                            }
                            disabled={
                              values.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
                            }
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicTwoOrMoreRacesEthnicitiesNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Other</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicOther"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicOther,
                              touched.raceEthnicOther,
                              values.raceEthnicOtherNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'raceEthnicOther')
                            }
                            value={
                              values.raceEthnicOtherNotCollected
                                ? ''
                                : values.raceEthnicOther
                            }
                            disabled={values.raceEthnicOtherNotCollected}
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicOtherNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Unknown / Unprovided</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicUnknown"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicUnknown,
                              touched.raceEthnicUnknown,
                              values.raceEthnicUnknownNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicUnknown'
                              )
                            }
                            value={
                              values.raceEthnicUnknownNotCollected
                                ? ''
                                : values.raceEthnicUnknown
                            }
                            disabled={values.raceEthnicUnknownNotCollected}
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicUnknownNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="">Total</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicTotalMembers"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className="ymca-field ymca-fieldDisabled"
                            value={calculateTotal(
                              values?.raceEthnicAsianNotCollected
                                ? 0
                                : values?.raceEthnicAsian,
                              values?.raceEthnicBlackOrAfricanAmericanNotCollected
                                ? 0
                                : values?.raceEthnicBlackOrAfricanAmerican,
                              values?.raceEthnicHispanicLatinoNotCollected
                                ? 0
                                : values?.raceEthnicHispanicLatino,
                              values?.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
                                ? 0
                                : values?.raceEthnicMiddleEasternOrNorthernAfrican,
                              values?.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
                                ? 0
                                : values?.raceEthnicNativeAmericanOrAlaskanNative,
                              values?.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
                                ? 0
                                : values?.raceEthnicNativeHawaiianOrOtherPacificIslander,
                              values?.raceEthnicWhiteNotCollected
                                ? 0
                                : values?.raceEthnicWhite,
                              values?.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
                                ? 0
                                : values?.raceEthnicTwoOrMoreRacesEthnicities,
                              values?.raceEthnicOtherNotCollected
                                ? 0
                                : values?.raceEthnicOther,
                              values?.raceEthnicUnknownNotCollected
                                ? 0
                                : values?.raceEthnicUnknown
                            )}
                            disabled
                          />
                        </td>

                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <span className="ymca-program p-0">
                  <h6 className="ymca-programActivities">
                    Please click in the checkbox if this Sex is not collected.
                  </h6>
                </span>
                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>No. of Staff</th>
                        <th className="ymca-defaultSpace">Not Collected</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td className="txt-mandatory">Female</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="genderFemale"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.genderFemale,
                              touched.genderFemale,
                              values.genderFemaleNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'genderFemale')
                            }
                            value={
                              values.genderFemaleNotCollected
                                ? ''
                                : values.genderFemale
                            }
                            disabled={values.genderFemaleNotCollected}
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="genderFemaleNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Male</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="genderMale"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.genderMale,
                              touched.genderMale,
                              values.genderMaleNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'genderMale')
                            }
                            value={
                              values.genderMaleNotCollected
                                ? ''
                                : values.genderMale
                            }
                            disabled={values.genderMaleNotCollected}
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="genderMaleNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Unknown / Unprovided</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="genderUnknown"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.genderUnknown,
                              touched.genderUnknown,
                              values.genderUnknownNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'genderUnknown')
                            }
                            value={
                              values.genderUnknownNotCollected
                                ? ''
                                : values.genderUnknown
                            }
                            disabled={values.genderUnknownNotCollected}
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="genderUnknownNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="">Total</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="genderTotalMembers"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className="ymca-field ymca-fieldDisabled"
                            value={calculateTotal(
                              values?.genderMaleNotCollected
                                ? 0
                                : values?.genderMale,
                              values?.genderFemaleNotCollected
                                ? 0
                                : values.genderFemale,
                              values?.genderUnknownNotCollected
                                ? 0
                                : values.genderUnknown
                            )}
                            disabled
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                  {totalIsNotEqual && (
                    <div className="d-flex flex-column">
                      <p className="errorNote  position-static fw-bold">
                        {errorMessageForTotal}
                      </p>
                    </div>
                  )}
                </div>

                {GetTotalStaffData?.data && (
                  <div className="ymca-submitHighlighter">
                    <LastUpdateName
                      Username={GetTotalStaffData?.data[0]?.UpdatedByName}
                      Time={GetTotalStaffData?.data[0]?.UpdatedDatetime}
                    />
                  </div>
                )}
                {role !== APP_LABELS.YUSA_DATA_VIEWER && (
                  <button
                    type="submit"
                    className="btn ymca-savingBTN ymca-btnRightUntitled float-end"
                    disabled={
                      status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED
                    }
                  >
                    Save
                  </button>
                )}
              </Form>
            );
          }}
        </Formik>
      </div>

      {successPopup && <SuccessToaster Status={resStatus} />}

      <ErrorPopup
        handleCloseErrorPopup={() => {
          setErrorPopup(false);
        }}
        errorMessage={errorMessage}
        showErrorPopup={errorPopup}
      />
      {help && <Help hidePopup={hideShowHelp} keyValue="total-staff" />}
    </>
  );
};

TotalStaff.propTypes = {
  setLoader: PropTypes.func.isRequired,
  handleResetRedux: PropTypes.func.isRequired,
  handleGetCampReportsDashboard: PropTypes.func.isRequired,
  handleGetOvernightCampDataTotalStaff: PropTypes.func.isRequired,
  handlePostOvernightCampDataTotalStaff: PropTypes.func.isRequired,

  status: PropTypes.objectOf(PropTypes.any).isRequired,
  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  ApiParameterData: PropTypes.objectOf(PropTypes.any).isRequired,
  GetTotalStaffData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapDispatchToProps = {
  handleResetRedux: resetReduxState,
  handleGetOvernightCampDataTotalStaff: getOvernightCampDataTotalStaff,
  handlePostOvernightCampDataTotalStaff: postOvernightCampDataTotalStaff,
  handleGetCampReportsDashboard: getCampReportsDashboardOverviewData
};

const mapStateToProps = state => ({
  ApiParameterData: ApiParaSelector(state),
  GetTotalStaffData: GetTotalStaffSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(TotalStaff));
